import * as amplitude from '@amplitude/analytics-browser';
import { initAmplitude } from './amplitudeInit';

export const events = {
  aimdDocumentsUploaded: 'AIMD Documents Uploaded',
  aimdGeneralPurposeCompleted: 'AIMD General Purpose Completed',
  aimdLearningObjectivesCompleted: 'AIMD Learning Objectives Completed',
  aimdStructureReviewed: 'AIMD Structure Reviewed',
  articleCreated: 'Content Article Created',
  attributesCreated: 'Attributes Created',
  copilotPromptSent: 'Copilot Prompt Sent',
  copilotWelcomeFlowCompleted: 'Copilot Welcome Flow Completed',
  defaultMentorCreated: 'Default Mentor Created',
  expertiseAdded: 'Expertise Added',
  levelCompleted: 'Level Completed',
  lessonCompleted: 'Lesson Completed',
  materialManuallyCreated: 'Material Manually Created',
  matchByAdmin: 'Match Created (Admin)',
  matchByRequest: 'Match Created (Request)',
  matchCancelled: 'Match Cancelled',
  matchCreated: 'Match Created',
  matchRequested: 'Match Requested',
  meetingCancelled: 'Meeting Cancelled',
  meetingCompleted: 'Meeting Completed',
  meetingJoinedSuccessfully: 'Meeting Joined Successfully',
  meetingNotJoined: 'Meeting Not Joined',
  meetingRated: 'Meeting Rated',
  meetingReviewed: 'Meeting Reviewed',
  meetingScheduled: 'Meeting Scheduled',
  memberDeactivated: 'Member Deactivated',
  mcqAnsweredCorrectly: 'MCQ Answered Correctly',
  mcqAnsweredIncorrectly: 'MCQ Answered Incorrectly',
  msObjectivesSettingsCompleted: 'MS Objectives + Settings Completed',
  msProgramNameAdded: 'MS Program Name Added',
  objectiveCompleted: 'Objective Completed',
  onboardingFieldsUpdated: 'Onboarding Fields Updated',
  organizationCreated: 'Organization Created',
  profileUpdated: 'Profile Updated',
  profileViewed: 'Profile Viewed',
  programActivated: 'Program Activated',
  programInDesign: 'Program In Design',
  programInvited: 'Program Invited',
  programMemberLabelsAdded: 'Program Member Labels Added',
  programPublished: 'Program Published',
  programReattempted: 'Program Reattempted',
  sourceAdded: 'Source Added',
  templateSelected: 'Template Selected',
  userAccepted: 'User Accepted',
  userAdopted: 'User Adopted',
  userEngaged: 'User Engaged',
  userInvited: 'User Invited',
  userMatched: 'User Matched',
  userOnboarded: 'User Onboarded',
  messageSent: 'Message Sent'
} as const;

export const attributeKeys = {
  completionStage: 'Completion Stage',
  documentType: 'Document Type',
  engagementStage: 'Engagement Stage',
  lastLogin: 'Last Login',
  matchCount: 'Match Count',
  objectiveScore: 'Objective Score',
  onboardingStatus: 'Onboarding Status',
  onboardedDate: 'Onboarded Date',
  organizationName: 'Organization Name',
  organizationType: 'Organization Type',
  progressScore: 'Progress Score',
  programModel: 'Program Model',
  programName: 'Program Name',
  programStatus: 'Program Status',
  resourceType: 'Resource Type',
  userName: 'User Name',
  userRole: 'User Role',
  meetingType: 'Meeting Type'
} as const;

export const attributeValues = {
  organizationType: ['Corporate', 'Higher Ed', 'Association'] as const
} as const;

export const eventTracking = (eventName: string, eventProperties: Record<string, any> = {}) => {
  initAmplitude(); // garante inicialização
  amplitude.track(eventName, eventProperties);
};
